import { CombinedSweep, GetPathRequestSweep } from 'src/service/navigation/types';

export const transformGetPathSweeps = (
  sweeps: Map<string, CombinedSweep>,
): GetPathRequestSweep[] => {
  return Array.from(sweeps.values()).map((sweep) => {
    const neighborsWithTreedisIds = sweep.neighbourSweeps
      ? sweep.neighbourSweeps.flatMap((neighborSweepId) => {
          const neighbor = sweeps.get(neighborSweepId);
          return neighbor ? [`${neighbor.id}`] : [];
        })
      : [];
    return {
      id: `${sweep.id}`,
      sweepId: sweep.sweepId,
      enabled: sweep.enabled,
      isCustom: sweep.isCustom,
      position: {
        x: sweep.positionX,
        y: sweep.positionY,
        z: sweep.positionZ,
      },
      neighbors: neighborsWithTreedisIds,
    };
  });
};

export const transformPathLineInputPath = (
  path: string[],
  sweeps: Map<string, CombinedSweep>,
): { data: any }[] => {
  return path
    .map((id) => sweeps.get(id))
    .filter((obj): obj is CombinedSweep => obj !== undefined)
    .map((obj) => {
      return {
        data: {
          ...obj,
          position: {
            x: obj.positionX,
            y: obj.positionY,
            z: obj.positionZ,
          },
        },
      };
    });
};
